import { ReactiveMicrocomponent } from "../ReactiveMicrocomponent";
import { AbstractTimer } from "./AbstractTimer";
import { Mode } from "./Mode";

export class DeadlineTimer extends AbstractTimer {
  public constructor(name: string, deadlineInput: ReactiveMicrocomponent<number>) {
    super(name, Mode.DEADLINE, null, deadlineInput);
  }
}
